export const MARKETING_URL_FIELD_NAMES = ["virtualTourUrl", "qrCodeUrl"] as const;

export const isMarketingUrlFieldName = (name: string) =>
  (MARKETING_URL_FIELD_NAMES as readonly string[]).includes(name);

/** Optional scheme — domain/path only, or full http(s) URL (paste). */
export const MARKETING_URL_INPUT_PATTERN =
  "^$|^(https?:\\/\\/)?([a-zA-Z0-9-]+\\.)+[a-zA-Z]{2,}(:\\d+)?(\\/[^\\s]*)?$";

export const stripMarketingUrlSchemeForDisplay = (value: unknown) => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  return trimmed.replace(/^https?:\/\//i, "");
};

/** Prepend https:// when saving if the user did not include a scheme. */
export const normalizeMarketingUrl = (value: unknown) => {
  const trimmed = String(value ?? "").trim();
  if (!trimmed) return "";
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed.replace(/^\/+/, "")}`;
};

export const createMarketingSlug = (value: string) =>
  value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

/** Join public list base URL with listing slug → full QR / barcode URL. */
export const buildMarketingQrCodeUrl = (baseUrl?: string, slug?: string) => {
  const base = String(baseUrl || "")
    .trim()
    .replace(/\/+$/, "");
  const path = String(slug || "")
    .trim()
    .replace(/^\/+/, "");

  if (!base && !path) return "";
  if (!base) return path;
  if (!path) return base;
  return `${base}/${path}`;
};
